<!-- 佣金记录 -->
<template>
  <div id="member-page">
    <!-- header start -->
    <van-nav-bar
      title=""
      left-arrow
      :border="false"
      @click-left="goBack"
      :safe-area-inset-top="true"
      fixed
      :placeholder="true"
      :z-index="99"
    />
    <div class="member-area-box">
      <img src="~@/assets/images/top-bg-2.png" alt="" class="bg" />
      <div class="profit-box">
        <div class="bd">
          <div class="profit-total">
            <div class="profit-total-tit">累计总收益(元)</div>
            <div class="profit-total-price">{{ totalPrice }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- header end -->
    <div class="search-box">
      <!-- <form > -->
      <div class="search-box-in">
        <img src="~@/assets/images/search_icon02.png" alt="" />
        <input
          ref="inputs"
          type="search"
          value=""
          v-model="inputVal"
          placeholder="请输入会员昵称或者手机号搜索"
          @search="onSearch"
        />
      </div>
      <!-- </form> -->
    </div>
    <div class="member-body">
      <van-tabs
        v-model="tabActive"
        sticky
        z-index="999"
        offset-top="46"
        :border="false"
        :swipe-threshold="4"
        background="#fff"
        color="#24a378"
        line-height="4px"
      >
        <van-tab title="普通会员">
          <MemberItem :keyWord="keyword" :level="1"></MemberItem>
        </van-tab>
        <van-tab title="直属代理"
          ><MemberItem :keyWord="keyword" :level="2"></MemberItem
        ></van-tab>
        <van-tab title="团队代理"
          ><MemberItem :keyWord="keyword" :level="-1"></MemberItem
        ></van-tab>
        <van-tab title="老板"
          ><MemberItem :keyWord="keyword" :level="3"></MemberItem
        ></van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import common from "../../../tools/common";
import { DatetimePicker } from "vant";
import MemberItem from "../../../components/MemberItem.vue";

export default {
  data() {
    return {
      tabActive: 0,
      inputVal: "",
      keyword: "",
      totalPrice: 0
    };
  },
  components: {
    MemberItem,
    [DatetimePicker.name]: DatetimePicker,
  },
  methods: {
    init() {
      var that = this;
      this.$store
        .dispatch({
          type: "GetSumCommission"
        })
        .then((res) => {
          common.Response.callNotMsgResponse(res, function(result) {
            that.totalPrice = result;
          });
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    onSearch() {
      console.log(this.inputVal);
      this.keyword = this.inputVal;
    },
  },
  watch: {
    tabActive(val, oldval) {
      let query = this.$router.history.current.query;
      let path = this.$router.history.current.path;
      //对象的拷贝
      let newQuery = JSON.parse(JSON.stringify(query));
      // 地址栏的参数值赋值
      newQuery.active = val;
      this.$router.replace({ path, query: newQuery });
    },
  },
  created() {
    this.tabActive = parseInt(this.$route.query.active);
    this.init();
  },
};
</script>
<style lang="less" scoped>
#member-page {
  padding-bottom: 15px;
}
.member-area-box {
  width: 100%;
  height: auto;
  padding-bottom: 10.5px;
  position: relative;
}

.member-area-box > .bg {
  width: 100%;
  display: block;
  position: absolute;
  top: 0;
  background-size: 100% 100%;
  height: 115px;
}
.profit-box {
  background: url("~@/assets/images/cash-bag.png") #fff right 25px center
    no-repeat;
  background-size: 42px 48px;
  padding: 18px 24px;
  margin: 0 10px;
  border-radius: 6px;
  z-index: 1;
  position: relative;
  margin-bottom: 15px;
  .bd {
    .profit-total {
      .profit-total-tit {
        font-size: 12px;
        color: #737373;
      }
      .profit-total-price {
        font-size: 21px;
        color: #1d1d1d;
        margin-top: 10px;
      }
    }
  }
}
//用户列表
.member-item {
  display: flex;
  align-items: center;
  margin: 20px 10px;
  .th {
    margin-right: 12px;
    .avatar {
      height: 52px;
      width: 52px;
      object-fit: cover;
      border-radius: 50%;
    }
  }
  .bd {
    flex: 1;
    overflow: hidden;
    .name {
      font-size: 14px;
      color: #000;
    }
    .date {
      font-size: 12px;
      color: #ababab;
      margin-top: 6px;
    }
  }
  .ft {
    margin-left: 5px;
    text-align: right;
    .tag-box {
      text-align: right;
      font-size: 0;
      .tag-item {
        display: inline-block;
        font-size: 10px;
        color: #fff;
        height: 18px;
        line-height: 18px;
        padding: 0 6px;
        border-radius: 3px;
        background: #ff2e56;
        margin-left: 4px;
      }
    }
    .price {
      font-size: 12px;
      color: #0a0a0a;
      margin-top: 4px;
    }
  }
}
.member-body {
  margin: 10px;
  padding: 15px;
  background: #fff;
  border-radius: 6px;
}

.search-box {
  width: 100%;
  height: auto;
  padding: 0 10px;
}

.search-box-in {
  width: 100%;
  height: 32px;
  background: #fff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  padding-left: 14px;
}

.search-box-in img {
  width: 12px;
  height: 12px;
  display: block;
  margin-right: 8px;
}

.search-box-in input {
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: #000;
  padding-right: 15px;
}

</style>

<style lang="less" >

#member-page {
  .van-nav-bar {
    background-image: url("~@/assets/images/top-bg-1.png");
    background-size: 100% 100%;
  }
  .van-nav-bar .van-icon {
    color: #fff;
    font-size: 20px;
  }
  .van-nav-bar__title {
    color: #fff;
  }
}
</style>
